import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import SwiperCore, { Pagination } from "swiper";
SwiperCore.use([Pagination]);

const cardData = [
  {
    title: "Take deposits. Stop no-shows.",
    subtitle:
      "Collect online deposits or full payments upfront. Cut no-shows and last-minute cancellations by up to 60% with Lokalai.",
    image: "https://images.pexels.com/photos/973406/pexels-photo-973406.jpeg",
  },
  {
    title: "Appointment reminders.",
    subtitle:
      "Set automatic, personalised reminders. Send email confirmations. Turn ‘maybes’ into ‘confirmed’. No more flakey clients.",
    image: "https://images.pexels.com/photos/3736520/pexels-photo-3736520.jpeg",
  },
  {
    title: "Manage your waitlist. Stay booked.",
    subtitle:
      "Track appointment requests. Fill cancellations fast. Let clients add themselves to the waitlist. Keep your calendar full.",
    image: "https://images.pexels.com/photos/3993443/pexels-photo-3993443.jpeg",
  },
  {
    title: "Protect your schedule. Protect your income.",
    subtitle:
      "Capture card details during online booking. Secure your time and charge no-shows automatically. Peace of mind, built in.",
    image: "https://images.pexels.com/photos/3993466/pexels-photo-3993466.jpeg",
  },
];

const ThirdBeauty = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleExpand = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  return (
    <div className="bg-black py-20 px-4">
      <div className="max-w-7xl mx-auto text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-semibold text-text mb-4">
          Say no to no-shows. Yes please.
        </h2>
        <p className="text-textGray text-lg max-w-3xl mx-auto">
          Reduce no-shows. Stay on top of cash flow. This is beauty salon
          software designed for you.
        </p>
      </div>

      <div className="max-w-7xl mx-auto">
        <Swiper
          pagination={{ clickable: true }}
          spaceBetween={30}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.2 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
          }}
        >
          {cardData.map((card, index) => (
            <SwiperSlide key={index}>
              <div
                className="bg-dry text-text rounded-3xl p-8 h-full flex flex-col justify-between shadow-xl min-h-[500px] cursor-pointer transition-all duration-300"
                onClick={() => toggleExpand(index)}
              >
                <div>
                  <h3 className="text-xl font-semibold whitespace-pre-line mb-4">
                    {card.title}
                  </h3>
                  <p
                    className={`text-sm mb-6 transition-all duration-300 ${
                      expandedCard === index ? "" : "line-clamp-3"
                    }`}
                  >
                    {card.subtitle}
                  </p>
                </div>
                <div className="w-full rounded-xl overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="object-contain mx-auto grayscale"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ThirdBeauty;
